@for (item of [1, 2]; track item) {
  <div class="skeleton-item">
    <ngx-skeleton-loader [theme]="{height: '10px', width:'40%', 'margin-bottom': '10px', 'margin-right': '50%' }" appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '10px', width:'40%', 'margin-bottom': '10px' }" appearance="line"></ngx-skeleton-loader>
    @for (item of [1, 2]; track item) {
      <div>
        <ngx-skeleton-loader [theme]="{height: '30px', width:'47.5%', 'margin-right': '5%', 'margin-bottom': '10px' }" appearance="line"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{height: '30px', width:'47.5%', 'margin-bottom': '10px' }" appearance="line"></ngx-skeleton-loader>
      </div>
    }
    <div>
      <ngx-skeleton-loader [theme]="{height: '60px', width:'47.5%', 'margin-right': '5%', 'margin-bottom': '20px' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '60px', width:'47.5%', 'margin-bottom': '20px' }" appearance="line"></ngx-skeleton-loader>
    </div>
    @for (action of [1, 2, 3, 4, 5]; track action) {
      <ngx-skeleton-loader [theme]="{height: '20px', width:'60%' }" appearance="line"></ngx-skeleton-loader>
    }
  </div>
  <div class="item-separator"></div>
}
